import { Form, InputStyled } from './style';
import { Box, Button, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { IProps, filters } from './models';
import { useEffect, useState } from 'react';
import moment from 'moment';

export const FilterForm = (props: IProps) => {
	const [form, setForm] = useState({
		...filters,
	});
	const [error, setError] = useState({ ...filters });

	useEffect(() => {
		setForm({ ...props.dataFilter });
	}, [props.dataFilter]);

	const handleChange = (event: any) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	const handleChangeDateInit = (date: any) => {
		if (!isNaN(date))
			setForm({
				...form,
				dataInicial: date,
			});
	};

	const handleChangeDateEnd = (date: any) => {
		if (!isNaN(date))
			setForm({
				...form,
				dataFinal: date,
			});
	};

	const saveFilter = () => {
		if (validDates()) {
			const dataInicial =
				form.dataInicial !== ''
					? moment(form.dataInicial).format('YYYY-MM-DD')
					: '';
			const dataFinal =
				form.dataFinal !== '' ? moment(form.dataFinal).format('YYYY-MM-DD') : '';

			props.onSave({
				...form,
				dataInicial,
				dataFinal,
			});
		}
	};

	const clearForm = () => {
		setForm({ ...filters });
		setError({ ...filters });
		props.onSave({ ...filters });
	};

	const validDates = () => {
		if (!form.dataInicial && form.dataFinal) {
			setError({ ...filters, dataInicial: 'Data Inicial Obrigatorio.' });
			return false;
		}
		if (form.dataInicial && !form.dataFinal) {
			setError({ ...filters, dataFinal: 'Data Final Obrigatorio.' });
			return false;
		}
		if (moment(form.dataFinal).isBefore(form.dataInicial)) {
			setError({
				...filters,
				dataFinal: 'Preencha com uma data Inferior a Inicial.',
			});
			return false;
		}
		setError({ ...filters });
		return true;
	};

	const formatDateToISO = (date: any) => {
		if (!date) return null;

		if (moment(date).isValid()) return date;

		const formated = date.split('/').reverse().join('-');
		return moment(formated).toDate();
	};
	return (
		<Box>
			<Form>
				<Box width={'50%'}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							label='Data Inicial'
							inputFormat='dd/MM/yyyy'
							value={formatDateToISO(form.dataInicial)}
							onChange={handleChangeDateInit}
							minDate={new Date('2000-01-01')}
							maxDate={new Date('2999-12-31')}
							renderInput={(params) => (
								<TextField
									{...params}
									InputLabelProps={{ shrink: true }}
									style={InputStyled}
									error={error.dataInicial ? true : false}
									helperText={error.dataInicial || ' '}
								/>
							)}
						/>
						<DatePicker
							label='Data Final'
							inputFormat='dd/MM/yyyy'
							value={formatDateToISO(form.dataFinal)}
							onChange={handleChangeDateEnd}
							minDate={new Date('2000-01-01')}
							maxDate={new Date('2999-31-12')}
							renderInput={(params) => (
								<TextField
									{...params}
									InputLabelProps={{ shrink: true }}
									style={InputStyled}
									error={error.dataFinal ? true : false}
									helperText={error.dataFinal || ' '}
								/>
							)}
						/>
					</LocalizationProvider>
				</Box>
			</Form>
			<Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<Button
					sx={{
						width: '10.4em',
						marginLeft: 'auto',
					}}
					color='secondary'
					variant='contained'
					onClick={saveFilter}
				>
					Salvar Filtro
				</Button>
				<Button
					sx={{
						width: '10.4em',
						marginLeft: '32px',
					}}
					color='secondary'
					variant='contained'
					onClick={clearForm}
				>
					Limpar
				</Button>
			</Box>
		</Box>
	);
};
